import axiosInstance from "@/utils/axiosInstance";
import { clearCache, wrapFetchValue } from "@/store/modules/storeCache";

const baseUrl = `api/options`;

const optionCacheNaming = (data: {
  resourceType: string, resourceId: number, optionTypeLabel: string,
}) => `${data.resourceType}-${data.resourceId.toString()}-${data.optionTypeLabel}`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  readOptionsByResource({ commit, state }, payload: {
    resourceType: string, resourceId: number, optionTypeLabelList: string[],
  }) {
    if (!payload.resourceId) {
      throw new Error("ERROR [readOptionsByResource] No resourceId in payload");
    }
    if (!payload.resourceId) {
      throw new Error("ERROR [readOptionsByResource] No resourceType in payload");
    }
    if (!payload.optionTypeLabelList) {
      throw new Error("ERROR [readOptionsByResource] No optionTypeLabelList in payload");
    }
    return axiosInstance.get(`${baseUrl}/${payload.resourceType}/${payload.resourceId}`,
      { params: { optionTypeLabel: payload.optionTypeLabelList } })
      .then((response) => {
        const data = response.data;
        data.sort((a, b) => payload.optionTypeLabelList.indexOf(a.optionTypeLabel) -
          payload.optionTypeLabelList.indexOf(b.optionTypeLabel));
        return data;
      });
  }, readOptionValueByResource({ commit, state, dispatch }, payload: {
    resourceType: string, resourceId: number, optionTypeLabel: string,
  }) {
    if (!payload.resourceType) {
      // tslint:disable-next-line:no-console
      console.error(payload);
      throw new Error("ERROR [readOptionValueByResource] No resourceType in payload");
    }
    if (!payload.resourceId) {
      // tslint:disable-next-line:no-console
      console.error(payload);
      throw new Error("ERROR [readOptionValueByResource] No resourceId in payload");
    }
    if (!payload.optionTypeLabel) {
      // tslint:disable-next-line:no-console
      console.error(payload);
      throw new Error("ERROR [readOptionValueByResource] No optionTypeLabel in payload");
    }
    return wrapFetchValue(state, optionCacheNaming(payload), () => dispatch("readOptionsByResource", {
      resourceType: payload.resourceType,
      resourceId: payload.resourceId,
      optionTypeLabelList: [payload.optionTypeLabel],
    })).then((data) => data[0].value);
  }, readOptionValueByRelay({ dispatch }, payload: {
    relayId: number, optionTypeLabel: string,
  }) {
    return dispatch("readOptionValueByResource", {
      resourceType: "relay", resourceId: payload.relayId, optionTypeLabel: payload.optionTypeLabel,
    });
  }, readOptionValueByBuilding({ dispatch }, payload: {
    buildingId: number, optionTypeLabel: string,
  }) {
    return dispatch("readOptionValueByResource", {
      resourceType: "building", resourceId: payload.buildingId, optionTypeLabel: payload.optionTypeLabel,
    });
  }, readType({ commit }, payload: {}) {
    return axiosInstance.get(baseUrl + "/types", {})
      .then((data) => data.data);
  }, updateByResourceId({ commit, state }, payload: {
    resourceType: string, resourceId: number, optionTypeLabel: string, value: string | number | boolean,
  }) {
    return axiosInstance.put(`${baseUrl}/${payload.resourceType}/${payload.resourceId}`, {
      optionTypeLabel: payload.optionTypeLabel, value: payload.value,
    })
      .then((data) => {
        clearCache(state, optionCacheNaming(payload));
        return data.data;
      });
  },
};
export default {
  namespaced: true, state, getters, actions, mutations,
};
